module.exports = __webpack_public_path__ + "media/images/lb/977-0ec143c8ad6cfeab8adf9d7d8c2abb39.svg";